import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const VanBus: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m210 430.67h30v134.33h-30z' />
    <path d='m510 765c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m120 765c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m160 690h305v30h-305z' />
    <path d='m20 560h195v30h-195z' />
    <path d='m210 660v-120s30 0 30 0v90c0 16.57-13.43 30-30 30z' />
    <path d='m630 720h-65v-30h35v-195c0-24.81-20.19-45-45-45h-446.89l-70.78 108.25c-4.8 7.34-7.34 15.86-7.34 24.63v107.12h45v30h-74.99v-137.12c0-14.62 4.23-28.82 12.23-41.05l79.66-121.83h463.11c41.36 0 75 33.64 75 75z' />
    <path d='m660 373.83c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m180.23 373.83c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m780 328.83h-75v-30h45v-195c0-24.81-20.19-45-45-45h-550.5l-59.52 119.04c-3.11 6.22-4.75 13.17-4.75 20.12v100.84h45v30h-75v-130.84c0-11.58 2.74-23.18 7.92-33.54l67.81-135.62h569.04c41.36 0 75 33.64 75 75z' />
    <path d='m220.23 298.83h399.77v30h-399.77z' />
    <path d='m600 207.66h-160s0-30 0-30h130c16.57 0 30 13.43 30 30z' />
    <path d='m390 327.66h-90v-210h90zm-60-30h30v-150h-30z' />
    <path d='m450 327.66h-90v-210h45c24.81 0 45 20.19 45 45zm-60-30h30v-135c0-8.27-6.73-15-15-15h-15z' />
    <path d='m85 177.66h235v30h-235z' />
  </IconBase>
));

VanBus.displayName = 'VanBus';

export default VanBus;
